// Editor / Studio hosts do not serve `/site-thumbnail`; wix.com does.
export const WIX_SITE_THUMBNAIL_ORIGIN = 'https://www.wix.com';

export function siteThumbnailUrl(metaSiteId: string): string {
  return `${WIX_SITE_THUMBNAIL_ORIGIN}/site-thumbnail/${metaSiteId}?preset=site-list`;
}

export function toAbsoluteSiteThumbnailUrl(
  imageUrl: string | undefined,
): string | undefined {
  if (!imageUrl) return undefined;
  if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
  const path = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
  return `${WIX_SITE_THUMBNAIL_ORIGIN}${path}`;
}

export function prefetchSiteThumbnail(metaSiteId?: string) {
  if (!metaSiteId || typeof Image === 'undefined') return;
  const img = new Image();
  img.src = siteThumbnailUrl(metaSiteId);
}
